import React from 'react';

export interface StatTileProps {
  label: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
  variant?: 'default' | 'dominant';
  className?: string;
}

export const StatTile: React.FC<StatTileProps> = ({ label, value, icon, variant = 'default', className = '' }) => {
  if (variant === 'dominant') {
    return (
      <div className={`bg-[#18365E] rounded-xl p-4 flex items-center gap-3 ${className}`}>
        {icon && (
          <div className="w-9 h-9 rounded-lg bg-white/20 flex items-center justify-center shrink-0 text-white">
            {icon}
          </div>
        )}
        <div className="min-w-0">
          <p className="text-[9px] font-semibold text-white/60 uppercase tracking-wide">{label}</p>
          <p className="text-base font-bold text-white leading-tight truncate">{value}</p>
        </div>
      </div>
    );
  }
  return (
    <div className={`bg-white rounded-xl border border-[#e5e7eb] p-4 flex items-center gap-3 ${className}`}>
      {icon && (
        <div className="w-8 h-8 rounded-lg bg-[#18365E]/10 flex items-center justify-center shrink-0 text-[#18365E]">
          {icon}
        </div>
      )}
      <div className="min-w-0">
        <p className="text-[9px] font-semibold text-[#717182] uppercase tracking-wide">{label}</p>
        <p className="text-sm font-bold text-[#18365E] truncate">{value}</p>
      </div>
    </div>
  );
};

export default StatTile;
